import { api } from './api'
import { InboxResponse, InboxStats, SentEmail } from '@/types'

export interface InboxFilters {
  handled?: boolean
  isPositive?: boolean
  limit?: number
  offset?: number
}

export interface SentEmailFilters {
  status?: string
  limit?: number
  offset?: number
}

export interface UpdateResponseRequest {
  handled?: boolean
  isPositive?: boolean
  notes?: string
}

interface InboxListResponse {
  success: boolean
  data: InboxResponse[]
  pagination: {
    total: number
    limit: number
    offset: number
  }
}

interface SentEmailListResponse {
  success: boolean
  data: SentEmail[]
  pagination: {
    total: number
    limit: number
    offset: number
  }
}

export const inboxService = {
  async getResponses(filters: InboxFilters = {}): Promise<InboxListResponse> {
    const response = await api.get<InboxListResponse>('/inbox', {
      params: filters,
    })
    return response.data
  },

  async getInboxStats(): Promise<InboxStats> {
    const response = await api.get<{ success: boolean; data: InboxStats }>('/inbox/stats')
    return response.data.data
  },

  async getSentEmails(filters: SentEmailFilters = {}): Promise<SentEmailListResponse> {
    const response = await api.get<SentEmailListResponse>('/inbox/sent', {
      params: filters,
    })
    return response.data
  },

  async updateResponse(id: number, data: UpdateResponseRequest): Promise<InboxResponse> {
    const response = await api.patch<{ success: boolean; data: InboxResponse }>(`/inbox/${id}`, data)
    return response.data.data
  },

  async deleteResponse(id: number): Promise<void> {
    await api.delete(`/inbox/${id}`)
  },

  async sendReply(id: number, data: { subject: string; body: string }): Promise<{ messageId: string; sentTo: string }> {
    const response = await api.post<{ success: boolean; data: { messageId: string; sentTo: string } }>(`/inbox/${id}/reply`, data)
    return response.data.data
  },
}
